// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';

const KEY_TOURNAMETS = 'tournaments'

export default {
  list(id) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child(KEY_TOURNAMETS)
        .orderByChild("id")
        .equalTo(id)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single-service.js